import axios from "axios";
import {API} from "@/env";

export default {
    show_FAQ(data) {
        const options = {
            method: 'GET',
            url: `https://wro-v.com/backend/api/web/getfaqs`,
            headers: {'content-type': 'application/json'},
            params: {...data},
        };

        return new Promise( (resolve,reject) =>  {
            axios(options).then( response => {
                resolve(response.data);
            }).catch( error => {
                reject(error.response.data);
            });
        });
    },


    category_FAQ() {

        const options = {
            method: 'GET',
            url: 'https://wro-v.com/backend/api/web/getcategory',
            headers: {'content-type': 'application/json'},
        };

        return new Promise( (resolve,reject) =>  {
            axios(options).then( response => {
                resolve(response.data);
            }).catch( error => {
                reject(error.response.data);
            });
        });

    }
}